export enum Projects {
  business = 'business',
  eola = 'eola',
  widget = 'widget'
}
